<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <span>Großhandel</span>
            </template>
        </navbar>

        <b-card>
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>ANREDE </span>
                    <span>{{ customer.customer_gender }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>VORNAME  </span>
                    <span>{{ customer.customer_fname }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>NACHNAME  </span>
                    <span>{{ customer.customer_lname }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>FIRMA  </span>
                    <span>{{ customer.customer_company_name }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>FIRMENZUSATZ  </span>
                    <span>{{ customer.customer_company_addition }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>STRAßE   </span>
                    <span>{{ customer.customer_street_name }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>HAUSNUMMER/STIEGE/TÌR   </span>
                    <span>{{ customer.customer_street_number }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>Land  </span>
                    <span>{{ customerCountry }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>PLZ   </span>
                    <span>{{ customer.customer_post_code }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>ORT</span>
                    <span>{{ customer.customer_city_name }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>UST-IDNR</span>
                    <span>{{ customer.customer_tax_info }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>E-MAIL</span>
                    <span>{{ customerEmail }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>TELEFON</span>
                    <span>{{ customer.customer_tel }}</span>
                </li>
                <li
                        v-if="customer.customer_file_url !== null"
                        class="list-group-item d-flex justify-content-between align-items-center">
                    <span>vCard hochladen</span>
                    <span>
                        <a :href="customer.customer_file_url">{{customer.customer_file_url}}</a>
                    </span>
                </li>
            </ul>
        </b-card>
    </div>
</template>

<script>
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import Navbar from "../Partials/Navbar";


    export default {
        name: "Details",
        components: {Navbar},
        data() {
            return {
                customer: [],
                customerCountry: null,
                customerEmail: null,

            }
        },
        methods: {
            getCustomer() {
                if (this.$route.params.customerid && this.$route.params.customerid > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'customer/show/' + this.$route.params.customerid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.customer = response.data.data.customer;
                                this.customerCountry = response.data.data.country;
                                this.customerEmail = response.data.data.email;
                            } else {
                                Notificaion.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getCustomer();
        }
    }
</script>

<style scoped>

</style>